import React from 'react';
import { Button } from 'react-bootstrap';
import { FaSeedling, FaRulerCombined, FaMap } from 'react-icons/fa';

export function buildToolkitTools({
  onOpenFeedManagement,
  onOpenPlantingAssistant,
  onOpenPrintableMap,
}) {
  return [
    {
      id: 'feeding',
      title: 'Feed Tracker',
      description:
        'Centralize status, refill ETAs, and analytics for every feeder across your land or club.',
      icon: <FaSeedling size={22} />,
      actionLabel: onOpenFeedManagement ? 'Open feed tracker' : 'Coming soon',
      disabled: !onOpenFeedManagement,
      onClick: onOpenFeedManagement,
    },
    {
      id: 'area',
      title: 'Planting',
      description:
        'Combine polygons to size seed and fertilizer orders across fields, food plots, and stands.',
      icon: <FaRulerCombined size={22} />,
      actionLabel: onOpenPlantingAssistant ? 'Open planting' : 'Coming soon',
      disabled: !onOpenPlantingAssistant,
      onClick: onOpenPlantingAssistant,
    },
    {
      id: 'printable-map',
      title: 'Printable Map',
      description:
        'Order a printed club map with your hunt boundary and title for clubhouse or members.',
      icon: <FaMap size={22} />,
      actionLabel: onOpenPrintableMap ? 'Order a map' : 'Coming soon',
      disabled: !onOpenPrintableMap,
      onClick: onOpenPrintableMap,
    },
  ];
}

export function ToolkitMenuContent({
  onOpenFeedManagement,
  onOpenPlantingAssistant,
  onOpenPrintableMap,
}) {
  const tools = buildToolkitTools({
    onOpenFeedManagement,
    onOpenPlantingAssistant,
    onOpenPrintableMap,
  });

  return (
    <>
      <p className="y-toolkit-description">
        Feed tracking, planting plans, and printable maps — switch tools with the tabs on each page.
      </p>
      <div className="y-toolkit-grid">
        {tools.map((tool) => (
          <div className="y-tool-card" key={tool.id}>
            <div className="y-tool-card-body">
              <div className="y-tool-icon" aria-hidden="true">
                {tool.icon}
              </div>
              <div>
                <div className="y-tool-card-title">{tool.title}</div>
                <div className="y-tool-card-description">{tool.description}</div>
              </div>
            </div>
            <Button
              variant="light"
              className="y-tool-card-action"
              disabled={tool.disabled}
              onClick={() => {
                if (tool.disabled || !tool.onClick) return;
                tool.onClick();
              }}
            >
              {tool.actionLabel}
            </Button>
          </div>
        ))}
      </div>
    </>
  );
}
